module.exports = __webpack_public_path__ + "img/three2Orange.7c785b1c.jpg";